// @copyright  2006 - 2022 West Indies Software Engineering Company Limited. All rights reserved.

export default {
    'report.page.title.journal_entry': 'Journal Entries',
    'report.page.title.transaction_report': 'Account Transactions',

    'report.label.batch_no': 'Batch No',
    'report.label.contact': 'Contact',
    'report.label.transaction_type': 'Transaction Type',
    'report.label.transaction_number': 'Transaction No.',
    'report.label.memo': 'Memo',
};
